<div class="bmc-empty-bots-list__empty">
    <h3>
        <ng-content></ng-content>
    </h3>
</div>